<svelte:options customElement={{
  tag: 'news-info',
  shadow: 'none',
  props: {
    items: { reflect: true, type: 'String' }
  }
}} />

<script>
  /**
   * NEWS お知らせリスト
   * シンプル日付＋タイトル型
   * @prop {string} items - JSON配列 '[{"date":"...","title":"...","href":"..."}]'
   */
  export let items = '[]';

  let parsedItems = [];

  $: {
    try {
      parsedItems = typeof items === 'string' ? JSON.parse(items) : (Array.isArray(items) ? items : []);
    } catch (e) {
      console.warn('NewsInfo: Invalid items JSON', e);
      parsedItems = [];
    }
  }
</script>

<ul class="mod-newsList02 rt_bn_news_info">
  {#each parsedItems as item}
    <li class="mod-newsList02__item rt_bn_news_info__item">
      <a href={item.href || '#'} class="mod-newsList02__link rt_bn_news_info__link" target={item.blank ? '_blank' : null} rel={item.blank ? 'noopener noreferrer' : null}>
        <time class="mod-newsList02__date rt_bn_news_info__date">{item.date || ''}</time>
        <p class="mod-newsList02__title"><span class="mod-newsList02__title-in rt_bn_news_info__title">{item.title || ''}</span></p>
      </a>
    </li>
  {/each}
</ul>
